import { render, staticRenderFns } from "./SalePricesAdditionalServicesProviderSelection.vue?vue&type=template&id=3c021faf"
import script from "./SalePricesAdditionalServicesProviderSelection.vue?vue&type=script&lang=js"
export * from "./SalePricesAdditionalServicesProviderSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports